var AttachDragTo = (function () {
    var _AttachDragTo = function (el) {
        this.el = el;
        this.mouse_is_down = false;

        this.init();
    };

    _AttachDragTo.prototype = {
        onMousemove: function (e) {
            if ( !this.mouse_is_down ) return;
            e.type === 'touchmove' && e.preventDefault();
            var tg = e.target,
                x = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX,
                y = e.type === 'touchmove' ? e.touches[0].clientY : e.clientY;

            tg.style.backgroundPositionX = x - this.origin_x + this.origin_bg_pos_x + 'px';
            tg.style.backgroundPositionY = y - this.origin_y + this.origin_bg_pos_y + 'px';
        },

        onMousedown: function(e) {
            this.mouse_is_down = true;
            this.origin_x = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
            this.origin_y = e.type === 'touchstart' ? e.touches[0].clientY : e.clientY;
        },

        onMouseup: function(e) {
            var tg = e.target,
                styles = getComputedStyle(tg);

            this.mouse_is_down = false;
            this.origin_bg_pos_x = parseInt(styles.getPropertyValue('background-position-x'), 10);
            this.origin_bg_pos_y = parseInt(styles.getPropertyValue('background-position-y'), 10);
        },

        init: function () {
            var styles = getComputedStyle(this.el);
            this.origin_bg_pos_x = parseInt(styles.getPropertyValue('background-position-x'), 10);
            this.origin_bg_pos_y = parseInt(styles.getPropertyValue('background-position-y'), 10);

            //attach events
            ['mousedown', 'touchstart'].forEach(event => this.el.addEventListener(event, this.onMousedown.bind(this), false));
            ['mouseup', 'mouseout', 'touchend'].forEach(event => this.el.addEventListener(event, this.onMouseup.bind(this), false));
            ['mousemove', 'touchmove'].forEach(event => this.el.addEventListener(event, this.onMousemove.bind(this), {passive:false}));
        }
    };

    return function ( el ) {
        new _AttachDragTo(el);
    };
})();

$('.pattern--block').each(function(i, elem) {
    AttachDragTo(elem);
});
$(document).ready(function () {
    $('.custom-prod-lazy').lazy({
        afterLoad:element=>{
            element.addClass('loaded')

            if (element.parents('#pattern_image--box').find('.custom-prod-lazy:not(.loaded)').length === 0){
                element.parents('#pattern_image--box').addClass('loaded')
                element.parents('#pattern_image--box').find('.loader').css({
                    'z-index':'-1',
                    'display':'none'
                })
            }
        }
    })
});


//---switchers
$('.pattern-switcher-item').click(function (e){
    if ($(this).hasClass('active')){
        return;
    }
    $('.pattern-switcher-item').removeClass('active')
    $(this).addClass('active')
    const blockId = $(this).attr('data-pattern-id')

    $('.image-item--box').attr('data-visible',false)
    $(`.image-item--box[data-pattern-id="${blockId}"]`).attr('data-visible',true)
})

    //---size slider
$(document).ready(function () {
    $('.pattern-slider').slider({
        min:15,
        max:200,
        value:80,
        orientation:window.innerWidth > 640?"vertical":"horizontal",
        slide:function (e,ui) {
            const id = $(this).attr('data-pattern-id')
            $(`.image-item--box[data-pattern-id="${id}"] .pattern--block`).css('background-size',ui.value+'%')
        },
        create:function (e,ui) {
            const id = $(this).attr('data-pattern-id')
            $(`.image-item--box[data-pattern-id="${id}"] .pattern--block`).css('background-size',ui.value+'%')
        }
    })
});
